import { render, staticRenderFns } from "./Breed.vue?vue&type=template&id=a05af95a&"
import script from "./Breed.vue?vue&type=script&lang=js&"
export * from "./Breed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports